/**
 * Updates the URL with a new or existing query string parameter without reloading the page.
 * @param {HTMLElement} [containerToAppend] - Optional: Parameter to specify an HTML element to update with fetched data.
 * @param {string} [urlFetch] - Optional: Parameter to specify the URL to fetch data from.
 * @param {string} param - Optional: The name of the query string parameter to update or set.
 * @param {number | string} id - Optional: The value of the query string parameter to set.
 * @param {Function} [callback] - Optional: A callback function to execute after the HTML is updated.
 * @param {Function} [secondCallback] - Optional: A second callback function to execute after the HTML is updated.
 * @returns {void}
 * @description This function updates the URL of the current page with a new or existing query string parameter.
 * If the specified parameter already exists in the URL, its value is updated to the new value.
 * If the specified parameter does not exist in the URL, it is added with the specified value.
 * @example
 * updateUrlParams(container, "/GetTest?test=1", "id", 123, initFunction());
*/
const updateUrlParams = (containerToAppend, urlFetch, param, id, callback, secondCallback) => {
    if (param && id) {
        // get the existing URL parameters and convert them to an object
        let params = Object.fromEntries(new URLSearchParams(window.location.search));
        if (param === 'performanceId') {
            const searchParams = new URLSearchParams(window.location.search);
            const paramToRemove = ['doctorId', 'venueId'];
            paramToRemove.forEach(param => searchParams.delete(param));
            const newQueryString = searchParams.toString();
            params = Object.fromEntries(new URLSearchParams(newQueryString));
        }
        if (id === null) {
            // Rimuove il parametro se `id` � null
            delete params[`${param}`];
        }
        else if (id) {
            // Aggiunge o aggiorna il parametro
            params[`${param}`] = `${id}`;
        }
        //// set the new URL parameters
        //params[`${param}`] = `${id}`;
        // convert the params object back to a query string
        const newParams = new URLSearchParams(params).toString();
        //const urlSearchParams = new URLSearchParams(window.location.search);
        //urlSearchParams.set(`${param}`, `${id}`);
        //urlSearchParams.delete("doctorId");
        //urlSearchParams.delete("venueId");
        //const updatedUrl = `${window.location.pathname}?${urlSearchParams}`;
        // update the URL without reloading the page
        history.pushState({}, '', `${window.location.pathname}?${newParams}`);
        // history.pushState({}, '', updatedUrl);
    }
    if (containerToAppend && urlFetch) {
        containerToAppend.innerHTML = "";
        fetch(urlFetch)
            .then(response => response.text())
            .then(data => {
            containerToAppend.innerHTML = data;
            if (typeof callback === "function") {
                callback();
            }
            if (typeof secondCallback === "function") {
                secondCallback();
            }
        });
    }
};
const handleFormValidation = () => {
    contactForms = document.querySelectorAll("[data-contact-form]");
    const formValidation = new FormsValidation();
    formValidation.initFormsValidation();
    // I need to delete the already created grecaptcha object when the form is printed after the API call.
    delete window.grecaptcha;
    initRecaptcha();
};
